import { useContext } from 'react';
import AuthContext from './AuthContext';
export var defaultAuthParams = {
    loginUrl: '/login',
    afterLoginUrl: '/',
};
/**
 * Get the authProvider stored in the context
 */
var useAuthProvider = function () { return useContext(AuthContext); };
export default useAuthProvider;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ra-core/esm/auth/useAuthProvider.js
// module id = 82
// module chunks = 0